import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            The New Waves Group Limited<span>®️</span>
          </h1>
          
          <p className="hero-subtitle">
            Leading the future through innovative ICT solutions, strategic projects, 
            and premium real estate development.
          </p>
          
          <div className="hero-buttons">
            <a href="#subsidiaries" className="btn btn-primary">
              Explore Our Companies
            </a>
            <a href="#contact" className="btn btn-secondary">
              Get In Touch
            </a>
          </div>
        </div>
        
        <div className="hero-visual">
          <div className="floating-cards">
            <div className="floating-card card-ict">
              <Link to="/ict-hub">
                <span>ICT Hub</span>
                <span>→</span>
              </Link>
            </div>
            
            <div className="floating-card card-projects">
              <Link to="/projects">
                <span>Projects</span>
                <span>→</span>
              </Link>
            </div>
            
            <div className="floating-card card-estate">
              <Link to="/estate">
                <span>Real Estate</span>
                <span>→</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
